<template>
  <div :id="hgReportAnchor" v-if="showList">
    <v-layout class="report-list">
      <v-flex class="title-column">
        <h3>REPORTS</h3>
      </v-flex>
      <v-flex>
        <div v-for="report in hgReports" :key="report.id" class="report">
          <button
            type="button"
            class="btn-tertiary report-btn"
            @click.stop="viewReport( report.link, report.id )">
            {{report.title}}
          </button>
          <span v-if="!report.viewed" class="new-badge">NEW</span>
          <span class="date"> {{dotDate(report.uploadDate)}}</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { DateTime } = Mixins;

export default {
  data() {
    return {
      selectedReportId: '',
    };
  },
  mixins: [DateTime],
  props: {
    hgReports: {
      required: true,
      type: Array,
    },
    hgReportBlock: {
      type: Boolean,
      required: true,
    },
    hgReportAnchor: {
      type: String,
      required: true,
    },
    hgFolderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    showList() {
      return this.hgReports.length > 0 && !this.hgReportBlock;
    },
  },
  methods: {
    viewReport(link, reportId) {
      this.$router.push({ name: 'reportView', params: { folderId: this.hgFolderId, reportId: reportId.toString() } });
    },
  },
};

</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.report-btn {
  font-size: 1.214rem;
}

.report {
  margin-bottom: 15px;
  margin-top: 15px;

  &:first-child {
    margin-top: 5px
  }
}

.date {
  color: rgba(0, 0, 0, 0.75);
  font-size: 1.143rem;
}

.title-column {
  flex: 0 0 180px;
}

.new-badge {
  background-color: $theme-color-primary;
  border-radius: 5px;
  color: $theme-color-white;
  padding: 2px 10px 3px 10px;
  font-weight: $typography-weight-bold;
  margin-right: 5px;
  margin-left: 5px;
  font-size: 0.786rem;
}

@media all and (max-width: 655px) {
  .report-list {
    flex-direction: column;
    margin-left: 30px;
  }

  .title-column {
    flex: 1 1 auto;
    padding-bottom: 20px;
  }
}
</style>
